import React from 'react';
import { Box, Container, Link, Typography, Divider, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 0,
        px: 2,
        mt: 'auto',
        minHeight: { xs: '140px', sm: '80px' },
        height: { xs: '140px', sm: '80px' },
        width: '100vw',
        position: 'relative',
        left: '50%',
        right: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Container maxWidth="lg" sx={{ p: 0 }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={0.5}
          alignItems="center"
          justifyContent="center"
          sx={{ height: '100%', minHeight: '100%', py: 1, width: '100%' }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 0.5, sm: 3 }}
            divider={<Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' } }} />}
            justifyContent="center"
            alignItems="center"
            sx={{ width: '100%' }}
          >
            <Link
              component={RouterLink}
              to="/privacy"
              color="text.secondary"
              sx={{ 
                textDecoration: 'none', 
                '&:hover': { 
                  textDecoration: 'underline',
                  color: 'primary.main' 
                },
                transition: 'color 0.2s',
                fontSize: { xs: '0.95rem', sm: '0.95rem' },
                whiteSpace: 'nowrap',
                mb: { xs: 0.5, sm: 0 }
              }}
            >
              Privacy Policy
            </Link>
            <Link
              component={RouterLink}
              to="/terms"
              color="text.secondary"
              sx={{ 
                textDecoration: 'none', 
                '&:hover': { 
                  textDecoration: 'underline',
                  color: 'primary.main' 
                },
                transition: 'color 0.2s',
                fontSize: { xs: '0.95rem', sm: '0.95rem' },
                whiteSpace: 'nowrap',
                mb: { xs: 0.5, sm: 0 }
              }}
            >
              Terms of Service
            </Link>
            <Link
              component={RouterLink}
              to="/third-party-notices"
              color="text.secondary"
              sx={{ 
                textDecoration: 'none', 
                '&:hover': { 
                  textDecoration: 'underline',
                  color: 'primary.main' 
                },
                transition: 'color 0.2s',
                fontSize: { xs: '0.95rem', sm: '0.95rem' },
                whiteSpace: 'nowrap',
                mb: { xs: 0.5, sm: 0 }
              }}
            >
              Third-Party Notices
            </Link>
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ 
                opacity: 0.8,
                fontWeight: 500,
                fontSize: { xs: '0.95rem', sm: '0.95rem' },
                whiteSpace: 'nowrap',
                mb: { xs: 0.5, sm: 0 }
              }}
            >
              © {new Date().getFullYear()} Battleground State
            </Typography>
          </Stack>
          <Typography
            variant="caption"
            color="text.secondary"
            align="center"
            sx={{ 
              opacity: 0.7,
              fontSize: { xs: '0.7rem', sm: '0.75rem' },
              mt: { xs: 0.5, sm: 0 },
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%'
            }}
          >
            Emoji artwork provided by Twemoji
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
} 